import { z } from "zod";
import { RequestFileDtoSchema } from "./RequestFileDto";

export const ScanAttachmentWithAIOutputSchema = z.object({
    fieldsToFillOut: z.record(z.string()).nullish(),
    files: RequestFileDtoSchema.array().nullish(),
});

export type ScanAttachmentWithAIOutput = z.infer<typeof ScanAttachmentWithAIOutputSchema>;